import { api } from "./apiConfig"

export const FaqsAPI = {
    get: async function () {
        const apiCall = await api();
        const response = await apiCall.request({
            url: "Faq/GetFaqs",
            method: "GET",
        })
        return response.data
    }
}